/*
 *   File : category-tab.js
 *   Author : https://evoqins.com
 *   Description : Category card component
 *   Integrations : NA
 *   Version : 1.0.0
*/

//Style
import style from "../../Styles/Component/card.module.scss";

const CategoryTab = (props) => {

    return (
        props.data.map((tab, key) => (
            <div key={key}
                className={`${props.activeTab === tab.id ? style.e_tab_active :
                    `${style.e_tab_inactive} cursor-pointer`} border-radius-8 ${tab.disabled ? "pe-none opacity-75" : ""} `}
                onClick={() => props.handleTabChange(tab.id)}>

                <div className='py-2 padding-12px-lr e-bg-white d-flex gap-2 align-items-center border-radius-8 w-100 h-100'>
                    <img src={require("../../Assets/Images/Card/basket-icon.svg").default}
                        draggable={false}
                        className="w-30px h-30 w-24px-res h-24px-res"
                        // width={30}
                        // height={30}
                        alt='category' />
                    <p className='e-font-14-res text-nowrap mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-400 line-height-20px'>
                        {tab.label}
                    </p>
                </div>

            </div>
        ))

    )
}



export default CategoryTab;
